const translations = {
  "en": {
    "360° Report": "360° Report",
    "Market": "Market",
    "News": "News"
  },
  "zh-tw": {
    "360° Report": "360°報告",
    "Market": "市場",
    "News": "新聞"
  }
};

export default translations;
